import { render, staticRenderFns } from "./PFAdvanceSlab.vue?vue&type=template&id=4944df92"
import script from "./PFAdvanceSlab.vue?vue&type=script&lang=js"
export * from "./PFAdvanceSlab.vue?vue&type=script&lang=js"
import style0 from "./PFAdvanceSlab.vue?vue&type=style&index=0&id=4944df92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports